<template>
  <v-dialog v-model="value" persistent max-width="800px">
    <material-card color="primary" :title="title">
      <v-form ref="form">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-data-table
                  :items="initialsList"
                  hide-actions
                >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th class="text-xs-left">Cin</th>
                    <th class="text-xs-left">Onset Date</th>
                    <th class="text-xs-left">Receipt Date</th>
                    <th class="text-xs-left">Verbatim reported</th>
                    <th class="text-xs-left"></th>
                  </tr>
                </template>
                  
                <template slot="items" slot-scope="{ item }" >
                  <td class="text-xs-left"><b>{{ item.cin }}</b></td>
                  <td class="text-xs-left">{{ item.ae_onset_date }}</td>
                  <td class="text-xs-left">{{ item.receipt_date }}</td>
                  <td class="text-xs-left">{{ item.ae_verbatim_reported }}</td>
                  <td class="text-xs-right">
                      <v-btn
                        small
                        color="purple"
                        @click="choose(item)"><v-icon small>mdi-checkbox-marked-outline</v-icon>  &nbsp;&nbsp;choose</v-btn>
                    </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()">Close</v-btn>
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, meddra, getDetail } from "@/api/adverse_event";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  props: {
    value: Boolean,
    choosed: String,
    title: String,
    initialsList: Array
  },
  data() {
    return {
      validators,
    };
  },
  mounted() {
  },
  watch: {
    value(v) {
    },
  
  },
  computed: {
    // title() {
    //   return "Multiple Initial case found for this SAE";
    // }
  },
  methods: {
    getData() {
      
      
    },
    close() {
      this.$emit("input", false);
    },
    choose(item) {
      this.$emit("update:choosed", item.cin);
      this.$emit("input", false);
    }
  }
};

</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
